export const TOKEN_REQUEST_TIME = 20_000;

export const STORAGE = {
	TOKEN: 'token',
	USER_DETAILS: 'userDetails',
	PAGE_SIZE: 'pageSize',
	LANGUAGE: 'lang'
};